import React from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import type { WorkflowRunStepStatus } from "./workflow.types";

export const STATUS_ICON: Record<WorkflowRunStepStatus, React.ReactNode> = {
  done: <CheckCircleIcon fontSize="small" sx={{ color: "success.main" }} />,
  failed: <ErrorIcon fontSize="small" sx={{ color: "error.main" }} />,
  skipped: <RemoveCircleOutlineIcon fontSize="small" sx={{ color: "text.disabled" }} />,
  not_reached: <HourglassEmptyIcon fontSize="small" sx={{ color: "text.disabled" }} />,
};
